import { getRegionImage } from '@/api/statics/request'
import EventBus from '@/utils/eventBus'

// TODO It should use a component for region images
// Because the unbind function will remove all listen callback
export default {
  inserted: async function (el, imageUrl) {
    EventBus.on('updated_current_region', async () => {
      el.src = await getRegionImage(imageUrl.value)
    })
    el.src = await getRegionImage(imageUrl.value)
  },
  unbind: function () {
    EventBus.off('updated_current_region')
  },
}
